import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import type { ReactNode } from "react";
import Styles from "./TableRow.module.scss";

type Props = DeepReadonly<{
	children: ReactNode;
}>;

export function TableRow({ children }: Props) {
	return <tr className={Styles.TableRow}>{children}</tr>;
}
